objects.is_onepage||objects.is_front_page;